// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TagChip_wrapper__3gnPD","slateGrey":"TagChip_slateGrey__2NYW1","transparent":"TagChip_transparent__3fjeR"};